import * as utils from 'OK/utils/utils';
import * as logger from 'OK/logger';

export abstract class JsonCustomHook<D> {
    el: HTMLElement;
    hookType: string;

    constructor(hookType: string, element: HTMLElement) {
        this.el = element;
        this.hookType = hookType;
    }

    activate() {
        const innerHtml = this.el.innerHTML;
        if (innerHtml) {
            this.parseAndProcessContent(innerHtml);
        }
    }

    setNewContent(html: string, activateChildren: boolean, deactivateChildren: boolean) {
        try {
            this.parseAndProcessContent(html);
        } catch (ex) {
            logger.errorEx(ex as Error, this.getHookId(), "cfg_papc");
        }
    }

    parseAndProcessContent(rawContent: string) {
        const content = utils.parseJson<D>(rawContent);
        if (content) {
            this.applyContent(content);
        }
    }

    getHookId() {
        return 'UnknownJsonHook';
    }

    abstract applyContent(content: D): void;
}